import React from 'react';
import TopBar from '../components/TopBar';
import PowerBIEmbed from '../components/PowerBIEmbed';

const NLWG = ({ userClaims }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <TopBar currentPage="nlwg-maturity" userClaims={userClaims} />
      
      <div className="p-4">
        <div className="bg-white shadow-md rounded-lg p-4">
          <h2 className="text-xl font-bold text-gray-800 mb-4">NLWG Dashboard</h2>
          <PowerBIEmbed reportId="51cec268-f116-4c34-9e35-e4cb7309f2f4" 
          workspaceId="7d441575-4aa9-4260-99dd-543f002c0340" 
          height={800} />
        </div>
      </div>
    </div>
  );
};

export default NLWG; 